import { captureEvent } from '@lib/observability/events/captureEvent';

import { LISTINGS_ANALYTICS_EVENTS } from './constants';

export function trackListingImportBatchStarted(input: {
  fileCount: number;
  skippedNonCsvCount: number;
  capped: boolean;
}): void {
  captureEvent(LISTINGS_ANALYTICS_EVENTS.IMPORT_BATCH_STARTED, input);
}
